import { fabric } from 'fabric';

export default class CanvasRenderer {
  constructor(canvas) {
    this.canvas = canvas;
  }

  refreshSelections(positions) {
    // Discard selected stale positions on canvas
    this.canvas.discardActiveObject();

    // Make a new selection with the updated positions
    const selection = new fabric.ActiveSelection(positions, { canvas: this.canvas });
    this.canvas.setActiveObject(selection)
    this.canvas.renderAll();
  }
}
